import { createRoutine } from '@hozana/routines/functions'

import type { TReportAbusePopinFormData } from 'general/popins/ReportAbusePopin'
import type { TReportAbusePayload } from 'general/sagas'

export const reportAbuse = createRoutine<'REPORT_ABUSE', TReportAbusePayload>('REPORT_ABUSE')
export const reportAbuseFormSubmit = createRoutine<'REPORT_ABUSE_FORM_SUBMIT', TReportAbusePopinFormData>(
  'REPORT_ABUSE_FORM_SUBMIT',
)
